export default __webpack_public_path__ + "static/media/gemstone.e3104fd6.png";